import React from 'react';
import classNames from 'classnames';
import Question from './Question';
import Answers from './Answers';
import Wreath from '../Wreath/Wreath';
import questions from '../../../slides';

const Questions = ({ view, changeView, scratcherPosition, incScratcherPos,
                    selectChoice, questions, numberOfQuestions, userId, sessionId }) =>  {

  const questionsClass = classNames({
    'scene': true,
    'scene--questions': true,
    'scene--hidden': view !== 'questions'
  });

  // map over questions
  const questionsList = questions.map((slide, index) =>
    <Question
      key={index}
      questionNumber={index + 1}
      scratcherPosition={scratcherPosition}
      numberOfQuestions={numberOfQuestions}
      question={slide.question}
    />
  );

  // map over answers
  const answersList = questions.map((slide, index) =>
    <Answers
      key={index}
      answers={slide.answers}
      leadText={slide.leadText}
      incScratcherPos={incScratcherPos}
      selectChoice={selectChoice}
      questionNumber={index + 1}
      scratcherPosition={scratcherPosition}
      numberOfQuestions={numberOfQuestions}
      userId={userId}
      sessionId={sessionId}
      questionId={slide.id}
    />
  );
  return (
    <div className={questionsClass}>
      <div className="scene__content">
        {questionsList}
        <div className="scene__content-right">
          <svg className="wreath wreath--questions" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 793.3 819.9" style={{enableBackground:'new 0 0 793.3 819.9'}}>
            <Wreath view={view} changeView={changeView} />
            {answersList}
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Questions;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Questions/QuestionsList.js
 **/